import { CountryType } from '@frodo/models/types';

export const globalErrorTrans: Record<CountryType, { [key: string]: string }> =
  {
    de: {
      exception:
        'Bei der Ausführung deiner Anfrage ist ein internes Problem aufgetreten. Bitte wende dich an unser Kundenbetreuungs-Team, falls dieser Fehler weiterhin auftritt.',
      'exception.explanation':
        'Unsere Techniker sind bereits über die Situation informiert worden. Versuche es bitte in einigen Minuten erneut.',
    },
    at: {
      exception:
        'Bei der Ausführung deiner Anfrage ist ein internes Problem aufgetreten. Bitte wende dich an unser Kundenbetreuungs-Team, falls dieser Fehler weiterhin auftritt.',
      'exception.explanation':
        'Unsere Techniker sind bereits über die Situation informiert worden. Versuche es bitte in einigen Minuten erneut.',
    },
    fr: {
      exception: 'Impossible de trouver la page',
      'exception.explanation':
        'Notre service technique a été informé du problème. Merci de réessayer dans quelques minutes.',
    },
    it: {
      exception:
        "Si è verificato un problema interno con la tua richiesta. Controlla il tuo account cliente per vedere se l'ordine è stato effettuato correttamente prima di effettuarlo di nuovo. Grazie",
      'exception.explanation':
        'I nostri tecnici sono già stati informati della situazione. Riprova tra qualche minuto.',
    },
    nl: {
      exception:
        'Er is een intern probleem opgetreden bij het verwerken van je verzoek. Controleer in je account of de bestelling succesvol is geplaatst voordat je deze opnieuw plaatst. Bedankt.',
      'exception.explanation':
        'Onze technici zijn al op de hoogte gebracht van de situatie. Probeer het over een paar minuten opnieuw.',
    },
  };
